/**
 * @internal
 */
export const BLOCK_SIZE: number = 64;

/**
 * @internal
 */
export const DIGEST_LENGTH: number = 16;

/**
 * @internal
 */
export const INIT = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476];
